import React from 'react';
import { Card, CardContent, Flex, FlexItem, Container, Paragraph, } from '@stepstone-genesis/components';
const Question = ({ content }) => {
    return (React.createElement(Container, { px: ['spaceNone', 'spaceNone'], m: 'spaceNone', ml: 'auto', sx: { maxWidth: '80% !important' } },
        React.createElement(Flex, { flxDirection: "column" },
            React.createElement(FlexItem, { flxJustify: "center" },
                React.createElement(Card, { variant: "compact", hasBorders: false, sx: {
                        backgroundColor: 'colorPrimarySubduedDefault',
                        borderRadius: 'radiusL4',
                    } },
                    React.createElement(CardContent, { py: "spaceS" },
                        React.createElement(Paragraph, { mb: "spaceNone", id: "aa", size: "small", lineHeight: "lineHeightXs" }, content)))))));
};
export default Question;
